import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="bg-brand-dark px-6 py-20 md:py-28" data-id="element-94">
      <div className="mx-auto max-w-3xl" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-96">
          <h2 className="text-2xl md:text-4xl font-bold text-white leading-tight mb-10 text-center" data-id="element-97">
            Si llevas meses en el Network Marketing y sientes que tu negocio no
            avanza,{' '}
            <span className="text-brand-gold" data-id="element-98">esto no es coincidencia.</span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6 text-lg text-slate-300 leading-relaxed" data-id="element-99">
          <p className="text-xl italic border-l-4 border-brand-gold pl-6 text-slate-200" data-id="element-100">
            "Si estás leyendo esto, probablemente ya pasaste por el momento más
            incómodo del Network Marketing:{' '}
            <strong className="text-white" data-id="element-101">
              quedarte sin gente a quién hablarle.
            </strong>
            "
          </p>

          <div className="space-y-4 mt-8" data-id="element-102">
            <p data-id="element-103">Has publicado Reels que nadie ve.</p>
            <p data-id="element-104">Has enviado mensajes en frío que terminan en "visto".</p>
            <p data-id="element-105">
              Has invitado a familiares que ahora cambian el tema cuando te ven.
            </p>
          </div>

          <p className="text-slate-400 mt-6" data-id="element-106">
            Y en algún punto, en silencio, te preguntaste si el problema eras
            tú.
          </p>

          <p className="text-2xl font-bold text-white mt-8" data-id="element-107">No eres tú.</p>

          <p data-id="element-108">
            El problema es que{' '}
            <strong className="text-white" data-id="element-109">te enseñaron a cazar</strong> en un
            mundo que solo responde a quien{' '}
            <strong className="text-brand-gold" data-id="element-110">atrae.</strong>
          </p>

          <p className="text-slate-400" data-id="element-111">
            La mayoría de Networkers cometen el mismo error: convierten su
            Instagram en un catálogo de productos aburrido o en un diario de
            frases motivacionales genéricas que no reclutan a nadie.
          </p>

          <p className="text-slate-400" data-id="element-112">
            Están usando estrategias de 1990 para un mercado de 2026.
          </p>
        </motion.div>

        {/* Por qué no funciona */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 text-center" data-id="element-113">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-114">
            Por Qué Todo lo que Has Intentado{' '}
            <span className="text-red-500" data-id="element-115">No Está Funcionando</span>
          </h3>
          <div className="w-20 h-1 bg-brand-gold mx-auto mt-4 mb-10 rounded-full" data-id="element-116"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-117">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-brand-darker border border-slate-800 rounded-xl p-6" data-id="element-118">
            <span className="text-3xl mb-4 block" data-id="element-119">❌</span>
            <h4 className="text-xl font-bold text-white mb-3" data-id="element-120">
              Publicar por publicar
            </h4>
            <p className="text-slate-400" data-id="element-121">
              Subir fotos del producto sin una estrategia de gancho solo te hace
              ver como un spammer más. Tu prospecto ideal te hace scroll sin
              detenerse.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-brand-darker border border-slate-800 rounded-xl p-6" data-id="element-122">
            <span className="text-3xl mb-4 block" data-id="element-123">❌</span>
            <h4 className="text-xl font-bold text-white mb-3" data-id="element-124">
              Cursos de Influencers
            </h4>
            <p className="text-slate-400" data-id="element-125">
              Te enseñan a ganar likes y seguidores. Pero los likes no pagan
              facturas ni construyen líneas de auspicio. Son métricas de vanidad
              disfrazadas de estrategia.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-brand-darker border border-slate-800 rounded-xl p-6" data-id="element-126">
            <span className="text-3xl mb-4 block" data-id="element-127">❌</span>
            <h4 className="text-xl font-bold text-white mb-3" data-id="element-128">
              Mensajes en frío masivos
            </h4>
            <p className="text-slate-400" data-id="element-129">
              Rogar por una presentación de 1 a 1 destruye tu postura y tu
              autoridad frente al prospecto antes de que la conversación
              empiece.
            </p>
          </motion.div>
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 text-center text-xl md:text-2xl text-slate-300 italic" data-id="element-130">
          No te culpes. Nadie te enseñó el método correcto.{' '}
          <strong className="text-brand-gold not-italic" data-id="element-131">Hasta hoy.</strong>
        </motion.p>
      </div>
    </section>;
}